import request from "@/utils/request";
import axios from "axios";

/**
    통계관리 > 회원통계 : 회원유형별 가입 통계
 **/
export async function getMemberTypeStatsList(params) {
    console.log("@@ get list : getMemberTypeStatsList");
    let result = request.get("/api/stats/memberType/",{params});
    return result;
}
export async function getMemberTypeStatsTotal(params) {
    console.log("@@ get list : getMemberTypeStatsTotal");
    let result = request.get("/api/stats/memberType/total",{params});
    return result;
}

/**
 통계관리 > 회원통계 : 지역별 가입 통계
 **/
export async function getMemberAreaStatsList(params) {
    console.log("@@ get list : getMemberAreaStatsList");
    let result = request.get("/api/stats/memberArea/",{params});
    return result;
}

export async function getMemberTypeStatsListExcelDownload(params, fileName) {
    console.log("@@ get list : getMemberTypeStatsListExcelDownload");
    const url = process.env.VUE_APP_ADM_API+"/api/stats/memberType/excel/download";
    axios.get(url, {
        params: params,
        responseType: "blob"
    })
    .then(response => {
        console.log(response);
        const a = document.createElement("a");
        const url = window.URL.createObjectURL(response.data);
        a.href = url;
        let date = new Date();
        a.download = fileName+'_'+date.yyyymmdd()+'.xlsx';
        a.click();
    })
    .catch(err => {
        console.log("error", err);
    })
}